// extracted by mini-css-extract-plugin
export default {"confirmation":"confirmation_UtsYy"};